/* eslint-disable no-await-in-loop */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'styled-components';
import { DivFooterDlg, Container } from './styles';
import {
  cloneObj,
  criaMensagemWhatsAppPedido,
  formatDate,
  formatFloat,
  getDiferencaEmHoras,
  strToDate,
} from '../../../../util/functions';
import PedidoService from '../../../../services/PedidoService';
import Dialog from '../../../../components/DialogCardapio';
import iconWahts from '../../../../assets/cardapio/icons/iconWhatsapp.png';

import Button from '../Button';
import ItemsPedido from './components';

function MeusPedidos(props) {
  MeusPedidos.propTypes = {
    setShowDialog: PropTypes.func.isRequired,
    showDialog: PropTypes.bool.isRequired,
    identificadorHtml: PropTypes.string.isRequired,
    whatsAppEmpresa: PropTypes.string,
  };
  const { showDialog, setShowDialog, identificadorHtml, whatsAppEmpresa } = props;
  const [listaPedidos, setListaPedidos] = useState([]);
  const theme = useTheme();

  const atualizaStatusDetalhe = useCallback(
    async lista => {
      // atualiza lista de pedidos
      for (let i = 0; i < lista.length; i++) {
        try {
          const pedido = await PedidoService.findByUuId(lista[i].uuId);
          lista[i].situacao = pedido.situacao;
          lista[i].tempoMinutosEntrega = pedido.tempoMinutosEntrega;
          lista[i].pedidoDetalhe = pedido.pedidoDetalhe;
          lista[i].pedidoEntrega = pedido.pedidoEntrega;
          lista[i].observacao = pedido.observacao;
        } catch (err) {
          lista[i].situacao = '';
        }
      }

      try {
        localStorage.setItem(`MeusPedidos_${identificadorHtml}`, JSON.stringify(lista));
      } catch (err) {
        //
      }
      setListaPedidos(cloneObj(lista));
    },
    [identificadorHtml]
  );

  const carregaPedidos = useCallback(() => {
    // recuperando pedido do localstorage
    const strListaMeusPedidos = localStorage.getItem(`MeusPedidos_${identificadorHtml}`);
    let listaMeusPedidos = [];

    if (strListaMeusPedidos) {
      try {
        listaMeusPedidos = JSON.parse(strListaMeusPedidos);

        if (!Array.isArray(listaMeusPedidos)) {
          listaMeusPedidos = [];
        }
      } catch (err) {
        //
      }
    }
    const dataAtual = new Date();

    const lista = listaMeusPedidos.filter(e => {
      const diferenca = getDiferencaEmHoras(dataAtual, strToDate(e.data, 'yyyy-MM-dd'));
      return diferenca < 96;
    });

    lista.sort((a, b) => {
      if (`${a.data}${a.hora}` > `${b.data}${b.hora}`) {
        return -1;
      }
      if (`${a.data}${a.hora}` < `${b.data}${b.hora}`) {
        return 1;
      }
      return 0;
    });

    setListaPedidos(lista);
    // atualizaStatusDetalhe;
    atualizaStatusDetalhe(lista);
  }, [atualizaStatusDetalhe, identificadorHtml]);

  useEffect(() => {
    if (showDialog) {
      carregaPedidos();
    }
  }, [carregaPedidos, showDialog]);

  function renderSituacaoItem(item) {
    let cor = '';
    let nomeLegenda = '';

    if (item.situacao === 'A') {
      cor = corAguardando;
      nomeLegenda = 'Aguardando';
    } else if (item.situacao === 'P') {
      cor = corPreparando;
      nomeLegenda = 'Em preparação';
    } else if (item.situacao === 'E') {
      cor = corEntregando;
      nomeLegenda = 'Entregando';
    } else if (item.situacao === 'F') {
      cor = corFinalizado;
      nomeLegenda = 'Entregue';
    } else if (item.situacao === 'C') {
      cor = corCancelado;
      nomeLegenda = 'Cancelado';
    } else if (item.situacao === '') {
      cor = '';
      nomeLegenda = 'Não definido';
    }

    return (
      <div className="legenda">
        {cor && <div style={{ background: cor }}>A</div>}
        <span>{nomeLegenda}</span>
      </div>
    );
  }

  const renderPedidos = pedidos => {
    // const existPedidoDelivery = pedidos.find(p => !p.retirarNoBalcao) !== undefined;

    return pedidos.map((ped, idx) => {
      const dataHora = `${formatDate(ped.data, 'dd/MM/yy')} ${ped.hora.substring(0, 5)}`;
      let previsao = 'Sem previsão';
      if (ped.tempoMinutosEntrega > 0) {
        previsao = `${ped.tempoMinutosEntrega} minutos`;
      }
      if (!Array.isArray(ped.pedidoDetalhe)) {
        ped.pedidoDetalhe = [];
      }

      if (!ped.pedidoEntrega) {
        ped.pedidoEntrega = {};
      }
      const msgWhats = criaMensagemWhatsAppPedido(ped);

      return (
        <div
          className="card"
          key={idx}
          style={{
            background:
              idx % 2 === 0 ? theme.colors.backgroundCardapio : theme.colors.colorZebrado,
          }}
        >
          <div className="linha" style={{ justifyContent: 'space-between' }}>
            <div className="div-caption-valor">
              <span className="titulo-caption">Data:</span>
              <span>{dataHora}</span>
            </div>
            <div className="div-caption-valor">
              <span className="titulo-caption" />
              <span>{renderSituacaoItem(ped)}</span>
            </div>
          </div>

          <div className="linha" style={{ justifyContent: 'space-between' }}>
            <div className="div-caption-valor">
              <span className="titulo-caption">Nome:</span>
              <span>{ped.nomeCliente}</span>
            </div>
          </div>

          <div className="linha" style={{ justifyContent: 'space-between' }}>
            <div className="div-caption-valor">
              <span className="titulo-caption">Previsão:</span>
              <span>{previsao}</span>
            </div>
            {/* <div
              className="div-caption-valor"
              style={{ justifyContent: 'flex-end', marginRight: 10 }}
            >
              <span className="titulo-caption">Vr. Total:</span>
              <span className="titulo-caption" style={{ textAlign: 'end' }}>
                {formatFloat(ped.valor, 2)}
              </span>
            </div> */}
          </div>

          <ItemsPedido pedido={ped} />

          {!ped.retirarNoBalcao && whatsAppEmpresa ? (
            <div
              className="linha"
              style={{ justifyContent: 'space-between', alignItems: 'center' }}
            >
              <div className="div-caption-valor">
                <a
                  href={`https://wa.me/55${whatsAppEmpresa}?text=${msgWhats}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button
                    text="Confirmar Pedido"
                    icon={iconWahts}
                    style={{
                      background: theme.colors.backgroundSacola,
                      borderColor: theme.colors.primary,
                      borderWidth: 1,
                      color: theme.colors.primary,
                      fontSize: 14,
                      fontFamily: 'Poppins',
                    }}
                    onClick={() => {
                      setShowDialog(false);
                    }}
                  />
                </a>
              </div>
              <div
                className="div-caption-valor"
                style={{ justifyContent: 'flex-end', marginRight: 5 }}
              >
                <span className="titulo-caption">SubTotal:</span>
                <span className="titulo-caption" style={{ textAlign: 'end' }}>
                  {formatFloat(ped.valor, 2)}
                </span>
              </div>
            </div>
          ) : (
            <div
              className="div-caption-valor"
              style={{ justifyContent: 'flex-end', marginRight: 5 }}
            >
              <span className="titulo-caption">SubTotal:</span>
              <span className="titulo-caption" style={{ textAlign: 'end' }}>
                {formatFloat(ped.valor, 2)}
              </span>
            </div>
          )}
        </div>
      );
    });
  };

  function renderFooter() {
    return (
      <Container>
        <DivFooterDlg>
          <Button
            text="Retornar"
            style={{
              width: 120,
              background: theme.colors.backgroundCardapio,
              borderColor: theme.colors.primary,
              borderWidth: 1,
              color: theme.colors.primary,
            }}
            onClick={() => setShowDialog(false)}
          />
        </DivFooterDlg>
      </Container>
    );
  }

  return (
    <Container>
      <Dialog
        closable
        title="Meus Pedidos"
        footer={renderFooter()}
        visible={showDialog}
        style={{
          minWidth: '350px',
          maxWidth: '450px',
          width: '95%',
          maxHeight: '90vh',
        }}
        contentStyle={{ maxHeight: '70vh', overflowY: 'auto', overflowX: 'hidden' }}
        setVisible={setShowDialog}
      >
        <div style={{ margin: -15, padding: 0, height: 25 }} id="div-add-item" />
        <div className="p-grid body">
          <div className="p-col-12 p-fluid">
            {listaPedidos.length <= 0 ? (
              'Não existe pedidos'
            ) : (
              <>
                <span className="titulo">Últimos pedidos</span>
                <div className="lista">{renderPedidos(listaPedidos)}</div>
              </>
            )}
          </div>
        </div>
      </Dialog>
    </Container>
  );
}

export default MeusPedidos;

const corAguardando = '#E94C3D';
const corPreparando = '#ece936';
const corEntregando = '#ff854a';
const corFinalizado = '#00a629';
const corCancelado = '#404c51';
